import "./App.css";
import Navbar from "./Navabr/Navbar";

function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
